<template>
  <div>
    <h1>{{ tituloh1 }}</h1>

    <div class="my-3">
      <div class="alert alert-info">
        ¡Atención!<br />
        Este email es exclusivo para <strong>{{ datosexpediente.firmantes[0].nombre }}</strong
        >, y se enviará por separado al correo correspondiente a la firma electrónica del contrato (email que se enviará a través del portal de gestion de firmas electrónicas: Signaturit).<br />
        El objetivo de este email es ofrecer un informe a modo de resumen a quien firme por parte de Manusa, relativo al expediente y aspectos importantes del contrato.<br />
        Adjunto a este correo, se enviará:<br />
        <ul>
          <li>Borrador del contrato que se enviará a firmar</li>
          <li>Hoja de validación del expediente, revisado y validado por los responsables</li>
        </ul>
      </div>
      <b-form-group class="mb-4" label-cols-lg="3" label-class="font-weight-bold pt-0" label="Mensaje personalizado" label-for="textarea-cuerpodelcorreo">
        <div><strong>Asunto:</strong> {{ asunto }}</div>

        <strong>Cuerpo del mensaje</strong>
        <div>
          {{ cabeceraemailfirmante }}<br />
          <b-form-textarea id="textarea-cuerpodelcorreo" v-model="cuerpoemailfirmante" :state="cuerpoemailfirmante.length >= 10" placeholder="Introduce al menos 10 caracteres" rows="5"></b-form-textarea><br />
          <div v-html="pieemailfirmante"></div>
        </div>
      </b-form-group>
      <div class="alert alert-info">Importante subrayar que este email se enviará en el <strong>PASO 5, CUANDO SE CONFIRME</strong> el envío del contrato a firmar y no antes.</div>
    </div>

    <div class="w-100 d-flex justify-content-between mb-4">
      <b-button @click="pasoatras" variant="danger">
        <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>
        Atrás
      </b-button>
      <b-button :disabled="!(cuerpoemailfirmante.length >= 10)" @click="siguientepaso" class="bgcolor-manusa">
        Siguiente
        <b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill>
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    tituloh1: {
      type: String,
      default: 'Edición del email privado que se enviará al firmante por parte de Manusa'
    },
    datosexpediente: Object
  },
  data() {
    return {
      asunto: '',
      cabeceraemailfirmante: '',
      cuerpoemailfirmante: '',
      pieemailfirmante: '',
      enlacepdfhojavalidacion: ''
    };
  },
  mounted() {
    const baseURL = process.env.VUE_APP_HOSTPYAPI;
    alert('[TODO] ATENCION AQUI... URL REQUIERE TRATAMIENTO ESPECIAL PARA PYAPI!!!!');
    //process.env.NODE_ENV !== 'production'?process.env.VUE_APP_API_MANUSA_DEV:process.env.VUE_APP_API_MANUSA_PROD
    this.enlacepdfhojavalidacion = baseURL + '/efirma/get-documento-de-expediente/' + this.datosexpediente.codigo + '/hojavalidacion';
    this.asunto = 'Informe/Hoja de validación para firma de contrato (EXPEDIENTE ' + this.datosexpediente.codigo + ')';
    this.cabeceraemailfirmante = 'Hola ' + this.datosexpediente.firmantes[0].nombre + ',';
    this.cuerpoemailfirmante = 'Envío la información relativa al contrato indicado en el asunto para que puedas llevar a cabo la firma del mismo, a través de Signaturit.';
    this.pieemailfirmante = '' + '<div>' + '    Adjunto a este correo, se enviará:<br>' + '    <ul>' + '        <li>Borrador del contrato que se enviará a firmar</li>' + "        <li><a href='" + this.enlacepdfhojavalidacion + "' target='_blank'>Hoja de validación</a> del expediente, revisado y validado por los responsables</li>" + '    </ul>' + '</div>' + 'Atentamente,<br />' + this.usuario_nombre;
  },
  methods: {
    siguientepaso() {
      const emailfirmante = {
        asunto: this.asunto,
        cuerpo: this.cabeceraemailfirmante + '\n' + this.cuerpoemailfirmante + '\n' + this.pieemailfirmante,
        adjuntos: ['contrato', 'hoja-validacion']
      };
      this.$emit('email-firmante-manusa-editado', emailfirmante);
    },
    pasoatras() {
      this.$emit('paso-atras');
    }
  },
  computed: {
    ...mapState(['user']),
    usuario_nombre: {
      get() {
        if (!this.user) return '';
        return this.user.nombre;
      }
    }
  }
};
</script>
